<template>
	<div class="page-area" @click="$emit('changeModelType', '')">
		<div class="login-area" @click.stop>
			<div class="nav-arae">
				<div
					class="nav"
					:class="{
						active: loginType === 0,
					}"
					@click="loginType = 0"
				>
					{{ $t("text1") }}
				</div>
				<div
					class="nav"
					:class="{
						active: loginType === 1,
					}"
					@click="loginType = 1"
				>
					{{ $t("text2") }}
				</div>
			</div>
			<div class="form-area" v-if="loginType === 0">
				<el-form
					:model="codeForm"
					:rules="codeRules"
					ref="codeFormRef"
					hide-required-asterisk
				>
					<el-form-item label=" " prop="PhoneNumber">
						<el-input
							v-model="codeForm.PhoneNumber"
							:placeholder="$t('text3')"
						></el-input>
					</el-form-item>
					<el-form-item label=" " prop="Code">
						<el-input
							v-model="codeForm.Code"
							:placeholder="$t('text4')"
						>
							<template slot="append">
								<div
									class="get-code"
									@click="handleSendCode"
									v-if="countDown.time === 60"
								>
									{{ countDown.text }}
								</div>
								<div class="get-code" v-else>
									{{ countDown.text }}
								</div>
							</template>
						</el-input>
					</el-form-item>
				</el-form>
				<div class="btn-area">
					<el-button
						class="btn"
						type="primary"
						@click="submitCodeForm"
					>
						{{ $t("text5") }}
					</el-button>
				</div>
			</div>
			<div class="form-area" v-if="loginType === 1">
				<el-form
					:model="loginForm"
					:rules="rules"
					ref="loginFormRef"
					hide-required-asterisk
				>
					<el-form-item label=" " prop="Identity">
						<el-input
							v-model="loginForm.Identity"
							:placeholder="$t('text3')"
						></el-input>
					</el-form-item>
					<el-form-item label=" " prop="Password">
						<el-input
							v-model="loginForm.Password"
							:placeholder="$t('text6')"
						>
						</el-input>
					</el-form-item>
				</el-form>
				<div class="btn-area">
					<el-button
						class="btn"
						type="primary"
						@click="submitLoginForm"
					>
						{{ $t("text5") }}
					</el-button>
				</div>
			</div>
			<div
				style="text-align: center;"
				@click="$emit('changeModelType', 'register')"
			>
				{{ $t("text7") }}
			</div>
		</div>
	</div>
</template>

<script>
import { setToken, setUser } from "@/utils/auth";
import {
	loginBySMSPhoneCode,
	sendLoginCode,
	login,
	getUserInfo,
} from "@/api/user";

export default {
	components: {},
	data() {
		return {
			loginType: 0,
			loginForm: {
				Identity: "",
				Password: "",
			},
			rules: {
				Identity: [
					{
						required: true,
						message: this.$t(`text8`),
					},
				],
				Password: [
					{
						required: true,
						message: this.$t(`text8`),
					},
				],
			},
			codeForm: {
				PhoneNumber: "",
				Code: "",
			},
			codeRules: {
				PhoneNumber: [
					{
						required: true,
						message: this.$t(`text8`),
					},
				],
				Code: [
					{
						required: true,
						message: this.$t(`text8`),
					},
				],
			},
			countDown: {
				time: 60,
				text: this.$t(`text9`),
			},
		};
	},
	mounted() {},
	methods: {
		submitLoginForm() {
			this.$refs["loginFormRef"].validate(async (valid) => {
				if (valid) {
					let { Data } = await login(this.loginForm);
					setToken(Data);
					this.$store.commit("user/SET_TOKEN", Data);

					let userInfo = await getUserInfo();
					this.$store.commit("user/SET_USER", userInfo.Data);
					setUser(userInfo.Data);

					this.$message({
						message: this.$t(`text10`),
						type: "success",
					});
					setTimeout(() => {
						this.$router.push({
							path: "/maintenance",
						});
					}, 500);
				}
			});
		},
		submitCodeForm() {
			this.$refs["codeFormRef"].validate(async (valid) => {
				if (valid) {
					let { Data } = await loginBySMSPhoneCode(this.codeForm);
					setToken(Data);
					this.$store.commit("user/SET_TOKEN", Data);

					let userInfo = await getUserInfo();
					this.$store.commit("user/SET_USER", userInfo.Data);
					setUser(userInfo.Data);

					this.$message({
						message: this.$t(`text10`),
						type: "success",
					});
					setTimeout(() => {
						this.$router.push({
							path: "/maintenance",
						});
					}, 500);
				}
			});
		},
		async handleSendCode() {
			if (this.codeForm.PhoneNumber === "") {
				this.$message({
					message: this.$t(`text11`),
					type: "error",
				});
				return;
			}

			let params = {
				PhoneNumber: this.codeForm.PhoneNumber,
			};
			let { Code } = await sendLoginCode(params);
			if (Code === 200) {
				const timer = setInterval(() => {
					this.countDown.time--;
					this.countDown.text = `${this.countDown.time}${this.$t(
						`text13`
					)}`;
					if (this.countDown.time === 0) {
						this.countDown.time = 60;
						this.countDown.text = this.$t(`text12`);
						clearInterval(timer);
					}
				}, 1000);
			}
		},
	},
};
</script>

<style scoped lang="scss">
::v-deep .el-input__inner {
	background-color: #d2dafa;
}
::v-deep .el-input-group__append {
	padding: 0;
}

.page-area {
	position: fixed;
	inset: 0;
	background: rgba($color: #000000, $alpha: 0.5);

	.login-area {
		position: absolute;
		left: 0;
		right: 0;
		bottom: 0;
		height: 400px;
		background-color: #fff;
		border-radius: 10px 10px 0 0;
		overflow: hidden;
		.nav-arae {
			display: flex;
			.nav {
				flex: 1;
				padding: 10px 0;
				text-align: center;
				font-size: 17px;
				font-weight: bold;
				background-color: #dadde4;
				color: #a4a6ab;
			}
			.active {
				background-color: #fff;
				color: #135192;
			}
		}
		.form-area {
			padding: 30px;
			.get-code {
				width: 120px;
				text-align: center;
			}
			.btn-area {
				display: flex;
				justify-content: center;
				margin-top: 50px;
				.btn {
					width: 60%;
					margin: 0 auto;
					background-color: #135192;
					border: none;
				}
			}
		}
	}
}
</style>
